module.exports = __webpack_public_path__ + "img/image7.45996de.webp";